<template>
  <el-card>
    <h2>欢迎 {{ user.name }} 回来...</h2>
  </el-card>

  <!-- <el-row :gutter="40" class="panel-group" v-if="countData.isAdministrator"> -->
  <!-- <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-people"><svg-icon icon-class="peoples" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">代理商总数量</div>
          <count-to :start-val="0" :end-val="countData.totalUserAmount" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-people"><svg-icon icon-class="people" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日新代理商总数</div>
          <count-to :start-val="0" :end-val="countData.todayRegUserCount" :duration="3000" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message"><svg-icon icon-class="skill" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">待审核代理商总数量</div>
          <count-to :start-val="0" :end-val="countData.toAuditUserCount" :duration="3200" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-message"><svg-icon icon-class="documentation" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日申请报单总数</div>
          <count-to :start-val="0" :end-val="countData.todayApplyDebitAdviceCount" :duration="3600" class="card-panel-num" />
        </div>
      </div>
    </el-col>

    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-money"><svg-icon icon-class="money" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">注册总金额(已通过)</div>
          <count-to :start-val="0" :end-val="countData.regTotalAmount" :duration="2600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-money"><svg-icon icon-class="money" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">充值总金额(已通过)</div>
          <count-to :start-val="0" :end-val="countData.rechargeTotalAmount" :duration="3000" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-shopping"><svg-icon icon-class="shopping" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">订单总数量(已通过)</div>
          <count-to :start-val="0" :end-val="countData.orderTotalAmount" :duration="3200" class="card-panel-num" />
        </div>
      </div>
    </el-col>
    <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
      <div class="card-panel">
        <div class="card-panel-icon-wrapper icon-shopping"><svg-icon icon-class="shopping" class-name="card-panel-icon" /></div>
        <div class="card-panel-description">
          <div class="card-panel-text">今日订单(已通过)</div>
          <count-to :start-val="0" :end-val="countData.todayOrderAmount" :duration="3600" class="card-panel-num" />
        </div>
      </div>
    </el-col>
  </el-row> -->
</template>

<script>
import { mapState } from 'vuex'
// import { desktop } from '@/api/index'
// import CountTo from 'vue-count-to'
export default {
  name: 'Index',
  components: {
    // CountTo,
  },
  data() {
    return {
      // countData: {
      //   totalUserAmount: 0,
      //   todayRegUserCount: 0,
      //   toAuditUserCount: 0,
      //   todayApplyDebitAdviceCount: 0,
      //   regTotalAmount: 0,
      //   rechargeTotalAmount: 0,
      //   orderTotalAmount: 0,
      //   todayOrderAmount: 0,
      //   beginTime: '',
      //   endTime: '',
      //   isAdministrator: false,
      // },
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.user,
    }),
  },
  watch: {
    $route: {
      async handler(newVal) {
        // const {
        //   data: { data },
        // } = await desktop(newVal.query)
        // this.countData = data
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 32px;
  }

  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);

    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }

      .icon-people {
        background: #40c9c6;
      }

      .icon-message {
        background: #36a3f7;
      }

      .icon-money {
        background: #f4516c;
      }

      .icon-shopping {
        background: #34bfa3;
      }
    }

    .icon-people {
      color: #40c9c6;
    }

    .icon-message {
      color: #36a3f7;
    }

    .icon-money {
      color: #f4516c;
    }

    .icon-shopping {
      color: #34bfa3;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }

      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}

@media (max-width: 550px) {
  .card-panel-description {
    display: none;
  }

  .card-panel-icon-wrapper {
    float: none !important;
    width: 100%;
    height: 100%;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 14px auto !important;
      float: none !important;
    }
  }
}
</style>
